import { render } from "./PerkConfigs.vue?vue&type=template&id=21a9743c&scoped=true"
import script from "./PerkConfigs.vue?vue&type=script&lang=js"
export * from "./PerkConfigs.vue?vue&type=script&lang=js"

import "./PerkConfigs.vue?vue&type=style&index=0&id=21a9743c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a9743c"]])

export default __exports__